import { render, staticRenderFns } from "./CadastreBuildingConstructiveFieldList.vue?vue&type=template&id=36d905fb&scoped=true&"
import script from "./CadastreBuildingConstructiveFieldList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingConstructiveFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d905fb",
  null
  
)

export default component.exports